import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { DemoData } from "src/services/demo/queries/NetTypes";
import { isValidToken } from "src/utils/jwt";

import Context from "../../../context";

export type VerifyForm = {
	email: string;
};

export default function useGetCurrentSesion() {
	const { actions } = useContext(Context);
	const queryClient = useQueryClient();
	const sessionToken = queryClient.getQueryData<string>(["demo", "sesion"]);
	const demoData = queryClient.getQueryData<DemoData>(["demo", "data"]);

	if (sessionToken && isValidToken(sessionToken) && demoData) {
		actions.onDemoFinished(demoData);
	}
}
